import { TourConfig } from "@/types/tour"
import { standardOffset } from "./utils/floatingUIConfigs"
import { ensureRoute } from "./utils/routeNavigation"
import WelcomeStep from "./steps/basic_variable/WelcomeStep.vue"
import AllowedValuesStep from "./steps/basic_variable/AllowedValuesStep.vue"
import TourCompleteStep from "./steps/basic_variable/TourCompleteStep.vue"
import { componentAsHtml } from "./utils/componentAsHtml"

/**
 * Tour configuration for the Basic Variable creation page
 */
export const basicVariableTour: TourConfig = {
   id: "basic_variable_tour",
   humanReadableName: "Basic Variable Tour",
   waitForElements: true,
   skippable: true,
   options: {
      useModalOverlay: true,
      defaultStepOptions: {
         classes: "q-card q-dark-transition shepherd-theme-quasar",
         arrow: true,
         scrollTo: { behavior: "smooth", block: "center" },
      },
   },
   steps: [
      {
         id: "welcome",
         title: "Welcome to Basic Variables",
         text: componentAsHtml(WelcomeStep),
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         beforeShowPromise: ensureRoute("CreateBasicVariable"),
      },
      {
         id: "human-readable-name",
         title: "Human Readable Name",
         text: `Name your variable clearly so your team knows what it's optimizing—e.g., "Call to Action Button Text" or "Hero Image".`,
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "[data-tour='human-readable-name-field']",
            on: "right",
         },
         floatingUIOptions: standardOffset,
         beforeShowPromise: ensureRoute("CreateBasicVariable"),
      },
      {
         id: "variable-key",
         title: "Variable Key",
         text: `Enter a unique, lowercase ID with no spaces—this is how your code will reference the variable (e.g., button_color, hero_text). Use this to identify the variable in your code.`,
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "[data-tour='variable-key-field']",
            on: "right",
         },
         floatingUIOptions: standardOffset,
         beforeShowPromise: ensureRoute("CreateBasicVariable"),
      },
      {
         id: "allowed-values",
         title: "Add Allowed Values",
         text: componentAsHtml(AllowedValuesStep),
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "[data-tour='allowed-values-field']",
            on: "right",
         },
         floatingUIOptions: standardOffset,
         beforeShowPromise: ensureRoute("CreateBasicVariable"),
      },
      {
         id: "tour-complete",
         title: "Ready to Create!",
         text: componentAsHtml(TourCompleteStep),
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  if (this.complete) return this.complete()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Complete",
            },
         ],
         floatingUIOptions: standardOffset,
         beforeShowPromise: ensureRoute("CreateBasicVariable"),
      },
   ],
}
